const COLLECTION = "/api/work-policy-applications";

export const workPolicyApplicationRoutes = {
  eligible: `${COLLECTION}/eligible`,
  staggeredTimes: (workPolicyId: number) =>
    `${COLLECTION}/policies/${workPolicyId}/staggered-times`,
  settlementPeriods: `${COLLECTION}/settlement-periods`,
  detail: (approvalRequestIdx: number) => `${COLLECTION}/${approvalRequestIdx}`,
  drafts: `${COLLECTION}/drafts`,
  draft: (approvalRequestIdx: number) =>
    `${COLLECTION}/${approvalRequestIdx}/draft`,
  submissions: `${COLLECTION}/submissions`,
  submit: (approvalRequestIdx: number) =>
    `${COLLECTION}/${approvalRequestIdx}/submit`,
  resume: (approvalRequestIdx: number) =>
    `${COLLECTION}/${approvalRequestIdx}/resume`
} as const;

export default workPolicyApplicationRoutes;
